import { Button, Icon, Modal } from '@paysera/ui';
import { useTranslation } from 'react-i18next';
const InvestmentComplete = ({ closeModal, isOpen }) => {
    const { t } = useTranslation();
    return (<Modal open={isOpen} size="md" className="!min-w-0 !max-w-[min(540px,calc(100vw-32px))]" onClose={closeModal} heading={t('financing.investment.title')} footer={<Button onClick={closeModal} variant="primary" label={t('financing.investment.got_it')}/>}>
            <div className="flex flex-col items-center gap-3 text-center">
                <div className="w-12 h-12 bg-surface-success-secondary-initial rounded-full border border-success-primary-initial flex justify-center items-center">
                    <Icon name="check_circle_filled" className="text-success-primary-initial"/>
                </div>
                <p className="body-m text-neutral-secondary-initial">{t('financing.investment.message')}</p>
            </div>
        </Modal>);
};
export default InvestmentComplete;
